import {
    NG_VALIDATORS,
    Validator,
    AbstractControl
} from '@angular/forms';
import { Directive, forwardRef, Attribute, Input } from '@angular/core';
import { DateService } from 'app/services/date.service';
@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[dateBefore][formControlName],[dateBefore][formControl],[dateBefore][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DateBeforeValidatorDirective),
            multi: true
        }
    ],
    standalone: false
})
export class DateBeforeValidatorDirective implements Validator {
    @Input() public dateBefore: string;
    @Input() reverse: string;
    @Input() errorMessage;
    constructor() { }
    private get isReverse() {

        return this.reverse === 'true' ? true : false;
    }
    private get message() {
        return this.errorMessage ? this.errorMessage : true;
    }
    validate(c: AbstractControl): { [key: string]: any; } {
        const date1 = c.value;
        let date2: AbstractControl = c.root.get(this.dateBefore);
        if (!!this.dateBefore && (date2 = c.root.get(this.dateBefore))) {

            if (date2 && DateService.isBefore(date1, date2.value) && this.isReverse) {

                date2.setValue(date1);
                return null;
            }

            if (date2 && DateService.isAfter(date2.value, date1) && this.isReverse) {
                // date2.setValue(date1);
                return null;
            }
            if (date2 && DateService.isAfter(date2.value, date1) && !this.isReverse) {
                date2.setValue(date1);

                return null;
            }
            if (date2 && DateService.isSame(date2.value, date1)) {
                date2.setErrors(null);
                return null;
            }
        }
        return null;
    }

}
